import { ds } from '@/ui/design-system'
import { nomadSearchFormShell } from './NomadSearchHero'

/** Shared field tokens for all moteur search forms (hotel reference). */

export const moteurFormShellEmbedded = nomadSearchFormShell

export const moteurBtnPrimary = ds.btnSoft

export const moteurLabelClass = [
  'mb-1.5 block text-xs font-semibold uppercase tracking-wide',
  'text-[var(--muted-foreground)]',
].join(' ')

export const moteurSelectTriggerClass = [
  ds.inputSm,
  'inline-flex items-center justify-between gap-2 text-left text-xs',
  'disabled:cursor-not-allowed',
].join(' ')

export const moteurLocationTriggerClass = [
  ds.inputSm,
  'inline-flex items-center justify-between gap-2 text-left text-sm',
  'disabled:cursor-not-allowed',
].join(' ')

/** Text inputs (destination, location autocomplete) matching hotel location scale */
export const moteurTextInputClass = [
  ds.inputSm,
  'text-sm',
].join(' ')

export const moteurNumericClass = [
  'font-[family-name:var(--font-mono)]',
  'tabular-nums',
].join(' ')

export const moteurDateTriggerClass = [
  moteurSelectTriggerClass,
  moteurNumericClass,
].join(' ')

export const moteurSearchDropdownClass = [
  'absolute left-0 right-0 top-full z-[200] mt-2 w-full max-h-60',
  'overflow-y-auto overflow-hidden rounded-[var(--radius-md)]',
  'border border-[var(--border)] bg-[var(--card)] shadow-[var(--shadow-md)]',
].join(' ')

export const moteurSearchDropdownItemClass = [
  'flex cursor-pointer items-center gap-2 px-3 py-2 text-xs',
  'text-[var(--foreground)] transition-colors',
  'hover:bg-[var(--muted)]',
].join(' ')

export const moteurLocationDropdownItemClass = [
  'flex cursor-pointer items-center gap-2 px-3 py-2 text-sm',
  'text-[var(--foreground)] transition-colors',
  'hover:bg-[var(--muted)]',
].join(' ')

export const moteurFieldErrorClass = ds.fieldError
